import React from 'react';
import PropTypes from 'prop-types';
import { localsMessages } from '../utility/getTemplateData';
import { HeadingText } from '@paypalcorp/pp-react-text';

class DebitOrCredit extends React.Component {
  render() {
    const guestMessages = localsMessages('guest/payCreditOrDebit') || {};
    const payCreditOrDebit =
      (guestMessages.label && guestMessages.label.payCreditOrDebit) || '';

    return (
      <div className="ppvx_row" style={{ maxWidth: 400, margin: '0 auto' }}>
        <div className="ppvx_col-sm-12">
          <HeadingText
            size="md"
            style={{ textAlign: 'center', marginBottom: '36px' }}
          >
            {payCreditOrDebit}
          </HeadingText>
        </div>
      </div>
    );
  }
}

DebitOrCredit.propTypes = {
  label: PropTypes.string,
};

export default DebitOrCredit;
